import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../../../core/services/http.service';
import { Subject } from 'rxjs/Subject';
import { EnvironmentService } from '../../../core/services/environment.service';

@Injectable()
export class ApiListService {

  public searchTextChange: Subject<string>;
  public apiListChange: Subject<number>;
  public apiListHit: number;

  private storeId: string;
  constructor(
    public httpService: HttpService,
    public envService: EnvironmentService
  ) {
    this.searchTextChange = new Subject<string>();
    this.apiListChange = new Subject<number>();

    this.storeId = this.envService.getStore('storeId');
    this.apiListHit = 0;
  }

  public getAllApis(searchKey?: string): Observable<any> {
    const url = 'stores/' + this.storeId  + '/apis';
    const payload = {};
    return this.httpService.get(url, payload);
  }

  public deleteApi(apiId?: string): Observable<any> {
    const url = 'stores/' + this.storeId  + '/apis/' + apiId;
    return this.httpService.delete(url);
  }

  public changeSearchText(searchText: string) {
    this.searchTextChange.next(searchText);
  }

  public reloadAPIList() {
    this.apiListHit++;
    this.apiListChange.next(this.apiListHit);
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/home/discover-api/api-list/api-list.service.ts